import { render, staticRenderFns } from "./Dag.vue?vue&type=template&id=2076fef2&"
import script from "./Dag.vue?vue&type=script&lang=ts&"
export * from "./Dag.vue?vue&type=script&lang=ts&"
import style0 from "./Dag.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports